import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { inventoryStockListQueryToApiParams } from '#/api/imsMgmt/inventoryStock/inventoryStockListQueryToApiParams';

export async function fetchInventoryStockList(listQuery) {
  const { data: raw } = await request.get('/inv/inventory-stock', {
    params: inventoryStockListQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
